const remote = {
    api: 'https://connectbot.burgers.io',
    ws: 'wss://connectbot.burgers.io',
}
const local = {
    api: 'http://localhost:11211',
    ws: 'ws://localhost:11211',
}
export default remote;
// export default local;